const AjaxSubmitFormHooks = (function() {
  let ajaxSubmitFormArgs;
  const callbackTransformers = [];
  function ajaxSubmitForm(action, form, callingFunctions, replaceContent, displaySpinner, _transformCallbacks) {
    if(_transformCallbacks)
      callbackTransformers.push(_transformCallbacks);
    shoptet.cart.ajaxSubmitForm(action, form, callingFunctions, replaceContent, displaySpinner);
    if(_transformCallbacks)
      callbackTransformers.splice(callbackTransformers.indexOf(_transformCallbacks), 1);
  }

  function ajaxSubmitFormAsync(action, form, callingFunctions, replaceContent, displaySpinner) {
    return new Promise((resolve, reject) => {
      AjaxSubmitFormHooks.ajaxSubmitForm(action, form, callingFunctions, replaceContent, displaySpinner, (callbacks) => {
        callbacks.success = tb.hooks.hookFn(callbacks.success, (success, args, context) => {
          const res = success.apply(context, args);
          resolve(args[0]);
          return res;
        });
        callbacks.failed = tb.hooks.hookFn(callbacks.failed, (failed, args, context) => {
          const res = failed.apply(context, args);
          reject(args[0]);
          return res;
        });
      });
    });
  }

  function hookAjaxSubmitFormCallbacks(transformCallbacks) {
    callbackTransformers.push((callbacks, args) => args && transformCallbacks(callbacks, args));
  }

  function init() {
    tb.hooks.hookFn("shoptet.cart.ajaxSubmitForm", function(ajaxSubmitForm, args, context) {
      ajaxSubmitFormArgs = args;
      ajaxSubmitForm.apply(context, args);
      ajaxSubmitFormArgs = null;
    });
    tb.hooks.hookFn("shoptet.ajax.makeAjaxRequest", function(makeAjaxRequest, args, context) {
      var callbacks = args[3];
      for(let transformCallbacks of callbackTransformers)
        transformCallbacks(callbacks, ajaxSubmitFormArgs);
      return makeAjaxRequest.apply(context, args);
    });
  }

  return { init, ajaxSubmitForm, ajaxSubmitFormAsync, hookAjaxSubmitFormCallbacks };
})();

const QuickFilterBox = (function($h, $t) {
  const config = {
    defaultCategories: [
      { url: "/vyber-podle-auta-sety/", text: "Střešní nosiče" },
    ],
    sortCallback: (options, $select) => {
      if($select.data("sort") === "numeric") {
        let collator = new Intl.Collator(undefined, { numeric: true });
        options.sort((a, b) => {
          return collator.compare(a.text, b.text);
        });
      } else if($select.data("sort") === "manual") {
        let manualOrder = $select.data("manualOrder");
        // console.log(manualOrder);
        options.sort((a, b) => {
          return manualOrder.indexOf(a.value) - manualOrder.indexOf(b.value);
        });
      } else if($select.data("sort") === "numericWidth") {
        let collator = new Intl.Collator(undefined, { numeric: true });
        options.sort((a, b) => {
          let aPriority =
            tb.common.parseNumber(a.value) >= 125 &&
            tb.common.parseNumber(a.value) <= 355,
            bPriority =
              tb.common.parseNumber(b.value) >= 125 &&
              tb.common.parseNumber(b.value) <= 355;

          if(aPriority !== bPriority) return bPriority - aPriority;

          return collator.compare(a.text, b.text);
        });
      }

      return options;
    },
    fallbackLang: $('html').attr('lang'),
    trans: {
      sk: {
        leftHtml: "Vyberte si produkty podľa Vášho auta: ",
        categoryLabel: "Kategorie",
        categoryLabelAcc: "kategorii",
        manufacturerLabel: "Značka",
        manufacturerLabelAcc: "značku",
        modelLabel: "Model",
        modalLabelAcc: "model",
        typeLabel: "Typ",
        pleaseSelectFirst: what => `Nejprve vyberte ${what}`,
        promptHtml: label => "Vyberte",
        clearLabel: "Vymazat filtr",
        submitLabel: "Zobrazit produkty",
        cartRefHeader: "Produkty, na které se zákazník dostal pomocí konfigurátoru:"
      },
      cs: {
        leftHtml: "Vyberte si produkty podle Vašeho auta: ",
        categoryLabel: "Kategorie",
        categoryLabelAcc: "kategorii",
        manufacturerLabel: "Značka",
        manufacturerLabelAcc: "značku",
        modelLabel: "Model",
        modalLabelAcc: "model",
        typeLabel: "Typ",
        pleaseSelectFirst: what => `Nejprve vyberte ${what}`,
        promptHtml: label => "Vyberte",
        clearLabel: "Vymazat filtr",
        submitLabel: "Zobrazit produkty",
        cartRefHeader: "Produkty, na které se zákazník dostal pomocí konfigurátoru:"
      },
      en: {
        leftHtml: "Choose products based on your car: ",
        categoryLabel: "Category",
        categoryLabelAcc: "category",
        manufacturerLabel: "Brand",
        manufacturerLabelAcc: "brand",
        modelLabel: "Model",
        modalLabelAcc: "model",
        typeLabel: "Type",
        pleaseSelectFirst: what => `Select first ${what}`,
        promptHtml: label => "Choose",
        clearLabel: "Clear filter",
        submitLabel: "Show products",
        cartRefHeader: "Produkty, na které se zákazník dostal pomocí konfigurátoru:"
      },
      de: {
        leftHtml: "Wählen Sie Produkte passend zu Ihrem Auto: ",
        categoryLabel: "Kategorie",
        categoryLabelAcc: "kategorie",
        manufacturerLabel: "Marke",
        manufacturerLabelAcc: "marke",
        modelLabel: "Modell",
        modalLabelAcc: "modell",
        typeLabel: "Typ",
        pleaseSelectFirst: what => `Zuerst auswählen ${what}`,
        promptHtml: label => "Wählen",
        clearLabel: "Löschen Sie den Filter",
        submitLabel: "Produkte ansehen",
        cartRefHeader: "Produkty, na které se zákazník dostal pomocí konfigurátoru:"
      }
    }
  };

  function renderSelector(catalogUrl) {
    function renderFormGroup(id, label, attrs = {}, options = []) {
      return $h(".selector__form-group", [
        $h("label", { for: attrs.id }, label + ":"),
        $h(".selector__select", [
          $h("select", attrs, [
            $h("option", { value: "", "data-prompt": "true", disabled: true, selected: true }, [t.promptHtml(label)]),
            ...options
          ])
        ])
      ]);
    }

    const categorySelect = catalogUrl ? null : renderFormGroup("category", t.categoryLabel, {
      "data-label": t.categoryLabelAcc,
    }, config.defaultCategories.map(({ url, text }) => $h("option", { value: url }, text)));

    return $h(".selector", [
      $h(".selector__left", [t.leftHtml]),
      $h(".selector__right", [
        $h("form.selector__form", { "data-catalog-url": catalogUrl }, [
          categorySelect,
          renderFormGroup("manufacturer", t.manufacturerLabel, {
            "data-subcategory": true,
            "data-label": t.manufacturerLabelAcc,
          }),
          renderFormGroup("model", t.modelLabel, {
            "data-subcategory": true,
            "data-label": t.modalLabelAcc,
          }),
          renderFormGroup("type", t.typeLabel, {
            "data-subcategory": true,
          }),

          $h(".selector__btn-wrap", [
            // $h("button.btn.btn-secondary.selector__reset-all", { type: "button" }, t.clearLabel),
            $h("button.btn.btn-default", { type: "submit" }, t.submitLabel),
          ]),
        ].flat())
      ]),
    ]);
  }

  function findFilterSection($page, parameterName) {
    return $page.find(".filter-section")
      .filter(function() {
        return $(this).find(">h4>span").text() === parameterName;
      })
      .first();
  }

  function extractFilterSectionOptions($section) {
    return $section.find("input[type=checkbox]").map(tb.common.iteratee$($t => {
      return {
        url: $t.data("url"),
        text: tb.dom.getTextShallow($t.next("label")).trim(),
        count: tb.common.parseNumber(
          $t.next("label").find(".filter-count").text()
        ),
        value: $t.attr("value"),
      };
    })).toArray();
  }

  function extractSubcategoryOptions($page) {
    return tb.dom.$map($page.find("#content ul.subcategories li>a"), $t => {
      const image = $t.find(".image img").attr("data-src");
      return {
        url: $t.attr("href"),
        text: $t.text().trim(),
        image: image.includes("folder.svg") ? null : image,
      };
    }).toArray();
  }

  function resetSelect($el) {
    $el = $($el);
    $el.prop("selectedIndex", 0).prop("disabled", true);
    $el.children().not("[data-prompt]").remove();
  }

  function getNextSelects($el) {
    const $selects = $el.closest("form").find("select");
    const elIndex = $selects.index($el);
    return $selects.slice(elIndex + 1);
  }

  function resetNextSelects($el) {
    var $last = $el;
    getNextSelects($el).each(function() {
      resetSelect(this);
      const lastLabel = $last.data("label") || $last.parent().prev("label").text();
      $(this).append(tb.$h("option", {
        disabled: true
      }, t.pleaseSelectFirst(lastLabel)));
      $last = $(this);
    });
  }

  function loadOptions($select, prevUrl) {
    if(!prevUrl)
      return Promise.resolve();

    return tb.ajax.loadDocument(prevUrl).then($page => {
      if($select.is("[data-subcategory]")) {
        return extractSubcategoryOptions($page);
      } else if($select.is("[data-parameter-name]")) {
        const $section = findFilterSection($page, $select.data("parameterName"));
        return extractFilterSectionOptions($section);
      }
    }).then((options) => {

      if(!options)
        return;

      options = config.sortCallback(options, $select);

      resetSelect($select);
      $select.prop("disabled", false);

      // const unavailableOptions = [];
      for(let item of options) {
        // if(item.count)
        $select.append(tb.$h("option", {
          value: item.url,
          "data-pv-slug": item.value,
          "data-image": item.image,
        }, item.text));
        // else
        //   unavailableOptions.push(tb.$h("option", {
        //     value: item.url,
        //     "data-pv-slug": item.value,
        //     disabled: true,
        //   }, item.text));
      }

      // if(unavailableOptions.length)
      // $select.append(tb.$h("optgroup", { label: "Není k dispozici v této kombinaci" }, unavailableOptions))

      resetNextSelects($select);
    });
  }

  function initSelect2($selector) {
    $selector.find("select").select2({
      minimumResultsForSearch: Infinity,
      templateResult(item) {
        if(item.disabled)
          return null;

        const image = $(item.element).data("image");
        return $h(".selector__option", [
          image ? $h("img", { src: image }) : null,
          $h("span", item.text)
        ]).toggleClass("--has-image", !!image);
      },
      templateSelection(item) {
        const image = $(item.element).data("image");
        return $h(".selector__selection", [
          image ? $h("img", { src: image }) : null,
          $h("span", item.text)
        ]).toggleClass("--has-image", !!image);
      }
    });
    tb.dom.$each($selector.find(".select2"), $container => {
      $container.css("width", Math.floor($container.width() - 1) + "px");
    });
  }

  function modifySearchParams(url, callback) {
    let foundSearch = false;
    url = url.replace(/\?[^#]*/, ($0) => {
      foundSearch = true;
      const newSearch = callback(new URLSearchParams($0)).toString();
      return newSearch !== "" ? "?" + newSearch : "";
    });
    if(!foundSearch)
      url = url.replace(/^[^#]*/, ($0) => {
        const newSearch = callback(new URLSearchParams()).toString();
        return $0 + (newSearch !== "" ? "?" + newSearch : "");
      });
    return url;
  }

  function addRefToLinks() {
    const ref = new URL(location.href).searchParams.get("ref");
    function modifyHref(i, href) {
      return modifySearchParams(href, params => {
        if(ref)
          params.set("ref", ref);
        else
          params.delete("ref");
        return params;
      });
    }
    $(".subcategories a, .pagination a, .p a").attr("href", modifyHref);
    $("#category-header input[name=order]").each(function() {
      $(this).attr("data-url", modifyHref);
    })
  }

  class JsonStorage {
    constructor(key, defaultFactory=(()=>({})), backend=window.sessionStorage) {
      this.key = key;
      this.defaultFactory = defaultFactory;
      this.backend = backend;
    }

    get() {
      const rawValue = this.backend.getItem(this.key);
      return rawValue === null ? this.defaultFactory() : JSON.parse(rawValue);
    }

    set(obj) {
      this.backend.setItem(this.key, JSON.stringify(obj));
    }

    clear() {
      this.backend.removeItem(this.key);
    }

    getAndUpdate(f) {
      const obj = f(this.get());
      this.set(obj);
      return obj;
    }
  }

  const cartRefStorage = new JsonStorage("QuickFilterBox.cartRef", () => ([]));

  let t;
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      t = tb.helpers.getStrings(config);
      AjaxSubmitFormHooks.hookAjaxSubmitFormCallbacks((callbacks, args) => {
        const [action, form] = args;
        if(action !== shoptet.config.addToCartUrl)
          return;
        const ref = new URL(location.href).searchParams.get("ref");
        if(!ref)
          return;
        const $form = $(form);
        let productName;
        if($form.is("#product-detail-form"))
          productName = $form.closest(".p-detail").find("meta[itemprop=name]").first().attr("content").trim();
        else {
          const $p = $form.closest(".p");
          if($p.length)
            productName = $p.find("[data-micro=name]").text().trim();
        }

        function saveCartRef() {
          return tb.ajax.loadDocument(ref).then($doc => {
            return tb.dom.$map($doc.find(".breadcrumbs > span").slice(3).find("[itemprop=name]"), $b => $b.text().trim()).toArray();
          }).catch(err => {
            console.error(err);
            return [];
          }).then(breadcrumbs => {
            cartRefStorage.getAndUpdate(cartRef => {
              cartRef.push({ productName, ref, breadcrumbs });
              return cartRef;
            });
          });
        }

        callbacks.success = tb.hooks.hookFn(callbacks.success, (success, args, context) => {
          saveCartRef().then(() => {
            success.apply(context, args);
          });
        })
      });

      $("#order-form.sending-order").on("ShoptetSuccessfulValidation", function(e) {
        $("#remark").val((i, userRemark) => {
          const cartRef = cartRefStorage.get();
          if(!cartRef.length)
            return userRemark;

          let remark = t.cartRefHeader + "\n";
          //   remark += cartRef.map(({ ref, productName }) => `- ${productName}: ${ref}`).join("\n");
          remark += cartRef.map(({ ref, productName, breadcrumbs }) => {
            return `- ${productName}: ${ref}, ${breadcrumbs.join(" > ")}`;
          }).join("\n");

          if(userRemark)
            remark += "\n\n" + userRemark;
          return remark;
        });
        cartRefStorage.clear();
      });

    },
    domReady: function() {
      $("body").on("change", ".selector__form select", function(e) {
        const $t = $(this);
        const $nextSelect = getNextSelects($t).first();
        if($nextSelect.length)
          loadOptions($nextSelect, $t.val());
      });
      $("body").on("click", ".selector__reset-single", function(e) {
        e.preventDefault();

        var $select = $(this).closest(".selector__select").find("select");

        $select.val("");
        resetNextSelects($select);
      });
      $("body").on("click", ".selector__reset-all", function(e) {
        e.preventDefault();

        var $firstSelect = $(this).closest("form").find("select").first();
        $firstSelect.val("");
        resetNextSelects($firstSelect);
      });


      $("body").on("submit", ".selector__form", function(e) {
        e.preventDefault();
    
        const $form = $(this);
        
        // Získání katalogové URL z datového atributu formuláře
        let lastUrl = $form.data("catalog-url");
    
        // Iterace přes všechny select prvky ve formuláři
        $form.find("select").each(function() {
            const value = $(this).val();  // Získání hodnoty z každého select
            if (value) {
                lastUrl = value;  // Aktualizace URL jen pokud select má hodnotu
            }
        });
    
        // Ověření, zda lastUrl obsahuje hodnotu
        if (!lastUrl) {
            console.log("No URL found");
            return;
        }
    
        // Přidání parametru ref s zakódovanou hodnotou URL
        lastUrl += "?ref=" + encodeURIComponent(lastUrl);
    
        // Rozhodnutí, zda zavolat AJAX nebo změnit URL
       // if ($("body.type-category").length) {
          console.log(lastUrl)
            makeFilterAjaxRequest(lastUrl, true, false, $form[0], "ShoptetPageFilterValueChange");
       // } else {
            location.href = lastUrl;  // Přesměrování na novou URL
       // }
        console.log(lastUrl)
    });
      $("body").on("click", ".selector__toggle-advanced", function(e) {
        e.preventDefault();
        $(this)
          .closest("form")
          .find(".selector__advanced-collapse")
          .toggleClass("--hidden");
      });
    },
    render() {
      tb.dom.$each(".selector-container", $el => {
        if(!tb.dom.oneTime($el, "QuickFilterBox"))
          return;
        const catalogUrl = $el.data("catalog-url") || config.defaultCategories[0].url;
        const $selector = renderSelector(catalogUrl).appendTo($el);
        initSelect2($selector);
      });

      var $form = $(".selector__form");
      if(tb.dom.oneTime($form, "QuickFilterBox")) {
        const $select = $form.find("select").first();
        resetNextSelects($select);

        const activeCategoryUrls = [
          ...tb.dom.$map(".breadcrumbs a", $a => $a.attr("href")).toArray(),
          location.pathname
        ];
        function setActiveOption($select) {
          const $activeOption = tb.dom.$filter($select.find("option"), $opt => activeCategoryUrls.includes($opt.attr("value")));
          if($activeOption.length) {
            $activeOption.prop("selected", true);
            $select.trigger("change");
            const $nextSelect = getNextSelects($select).first();
            if($nextSelect.length)
              return loadOptions($nextSelect, $select.val()).then(() => setActiveOption($nextSelect));
          }
        }
        loadOptions($select, $form.data("catalogUrl")).then(() => setActiveOption($select));
      }
      addRefToLinks();
    },
  });

  return { init: init };
})(tb.$h, tb.$t);

(function() {
  AjaxSubmitFormHooks.init();
  QuickFilterBox.init();

  //setTimeout(function(){
  //  $("select[data-label='kategorii']").val('Strešné nosiče');
  //  $("select[data-label='kategorii'] option").filter(function (){return $(this).attr('value') == '/vyber-podla-auta-sety/'}).change().prop("selected", true)
  //  console.log($("select[data-label='kategorii'] option").text())
  //}, 100)


})();
